import { createSlice } from '@reduxjs/toolkit'
import { accEntrySearchMain, destroyAccEntrySearch } from './accEntry-search.actions'
import { AccEntrySearchParams } from '@lk/api'

type CommentsState = {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string | null
  data: unknown[]
  searchParams: AccEntrySearchParams | null
}

const initialState: CommentsState = {
  status: 'idle',
  error: null,
  data: [],
  searchParams: null,
}

const AccEntrySlice = createSlice({
  name: 'AccEntrySearchSlice',
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [accEntrySearchMain.pending.toString()]: (state) => {
      state.status = 'loading'
      state.data = []
    },
    [accEntrySearchMain.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
      state.error = null
      if (!!action.meta.arg && Object.keys(action.meta.arg).length > 0) {
        state.searchParams = action.meta.arg
      }
    },
    [accEntrySearchMain.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.data = []
      state.error = action.payload
      state.searchParams = null
    },
    [destroyAccEntrySearch.toString()]: () => {
      return initialState
    },
  },
})

export default AccEntrySlice.reducer
